import React from 'react';

import {
  RedirectAuthButton,
  type RedirectAuthButtonProps,
  type RedirectAuthProvider,
  type RedirectIntent,
} from '../oauth/RedirectAuthButton';
import { AppleBrandIcon } from './AppleBrandIcon';

/** @public */
export type AppleRedirectIntent = RedirectIntent;
export type AppleAuthRedirectButtonProps = RedirectAuthButtonProps;

const APPLE_PROVIDER: RedirectAuthProvider = {
  authPath: '/auth/apple',
  authMethod: 6,
  providerName: 'Apple',
  defaultLabel: 'Continue with Apple',
  idPrefix: 'apple',
  Icon: AppleBrandIcon,
  // Figma uses the solid near-black `background-inverse/primary` (#23201d);
  // the secondaryInverse variant defaults to the lighter inverse-secondary, so
  // override the bg + hover/active here. Text/glyph stay white via the variant.
  buttonClassName:
    'border-transparent bg-od-bg-inverse-primary not-disabled:hover:border-transparent not-disabled:hover:bg-od-bg-inverse-hover-primary not-disabled:active:border-transparent not-disabled:active:bg-od-bg-inverse-pressed-secondary',
};

/**
 * Redirect-based Apple auth button for the server-side OAuth flow.
 * Navigates to /auth/apple — Rails handles the full OAuth exchange via OmniAuth.
 * No Apple JavaScript SDK in the login path. Sibling to GoogleAuthRedirectButton.
 */
export const AppleAuthRedirectButton: React.FC<AppleAuthRedirectButtonProps> = (props) => (
  <RedirectAuthButton {...props} provider={APPLE_PROVIDER} />
);
